import React from 'react';
import { StyledSvgIcon } from "./SvgIcon";
export var SvgSocialIcon = function SvgSocialIcon(_ref) {
  var ariaLabel = _ref['aria-label'],
    children = _ref.children,
    size = _ref.size,
    contrast = _ref.contrast,
    intent = _ref.intent;
  return /*#__PURE__*/React.createElement(StyledSvgIcon, {
    "aria-hidden": ariaLabel ? undefined : true,
    "aria-label": ariaLabel,
    role: "img",
    size: size,
    contrast: contrast !== null && contrast !== void 0 ? contrast : undefined,
    intent: intent !== null && intent !== void 0 ? intent : undefined,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, children);
};